import axios from "axios"
import React, { useRef, useState } from "react"
import Button from "../Button/Button"
import "./Newsletter.scss"
import parse from "html-react-parser"

const Newsletter = ({
    className,
    context = {
        pageName: "SD | Case studies",
        pageUri: "https://saigon.digital/"
    }
}) => {
    const $input = useRef(null)
    const [error, setError] = useState("")
    const [visibility, setVisibility] = useState(true)
    const [thankMess, setThankMess] = useState("")

    const styleSheet = useRef(null)

    const SPARK_ELEMENT_WIDTH = 20
    const DISTANCE = 20

    const onSubmit = async e => {
        e.preventDefault()

        setError("")
        if (!$input.current.value) {
            setError("Please input your email!")
            return
        }

        const regex = /\S+@\S+.\S+/

        if (!regex.test($input.current.value)) {
            setError("Please input correct email format!")
            return
        }

        const portalId = process.env.GATSBY_HUBSPOT_NEWSLETTER_ID
        const formGuid = process.env.GATSBY_HUBSPOT_NEWSLETTER_GUID
        const config = {
            // important!
            headers: {
                "Content-Type": "application/json"
            }
        }

        const center = { x: e.pageX, y: e.pageY }
        makeBurst(center)

        const response = await axios.post(
            `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
            {
                portalId,
                formGuid,
                fields: [
                    {
                        name: "email",
                        value: $input.current.value
                    }
                ],
                context
            },

            config
        )

        if (response.status === 200) {
            setThankMess(response.data.inlineMessage)
            setVisibility(false)
        }
    }

    /**
     * A burst is a grouping of many sparks
     * A spark is some individual dom element generally used with other sparks to create interesting UI effects.
     **/

    /**
     * Util for creating sequences of css transform steps cleanly
     */
    function createTransformSteps() {
        const inputSteps = Array.from(arguments)
        const outputSteps = [inputSteps.shift()]
        inputSteps.forEach((step, i) => {
            outputSteps.push(`${outputSteps[i]} ${step}`)
        })

        return outputSteps
    }

    /**
     * Creates a new keyframe rule available in css context with a specific spark rotation
     */
    const dynamicAnimation = (name, rotation) => {
        if (!styleSheet.current) {
            styleSheet.current = document.createElement("style")
            styleSheet.current.type = "text/css"
            document.head.appendChild(styleSheet.current)
        }

        /**
      Explaining the transform rules
      1. prepares spark
      2. shoots the spark out
      3. keeps the spark in place while scaling it down
    */

        const randomDist = Math.floor((Math.random() - 0.5) * DISTANCE * 0.7)

        const [s1, s2, s3] = createTransformSteps(
            `translate(-50%, -50%) rotate(${rotation}deg) translate(10px, 0px)`,
            `translate(${DISTANCE + randomDist}px, 0px) scale(0.5, 0.5)`,
            `translate(${SPARK_ELEMENT_WIDTH / 2}px, 0) scale(0, 0)`
        )

        // todo some axis would be good here.
        styleSheet.current.sheet.insertRule(
            `@keyframes ${name} {
         0% {
           transform: ${s1};
         }
         70% {
           transform: ${s2};
         }
         100% {
           transform: ${s3};
         }
      }`,
            styleSheet.current.length
        )
    }

    const makeBurst = center => {
        for (let i = 0; i < 8; i++) {
            const randomSpace = Math.floor(-17 + Math.random() * 34)

            makeSpark(center, 45 * i + randomSpace)
        }
    }

    /**
     * Creates a spark
     */
    const makeSpark = (center, rotation) => {
        const div = document.createElement("div")
        const aniName = `disappear_${rotation}`
        dynamicAnimation(aniName, rotation)

        div.classList.add("newsletter-spark")
        div.style.left = `${center.x}px`
        div.style.top = `${center.y}px`
        div.style.animation = `${aniName} 500ms ease-out both`

        document.body.append(div)
    }

    return (
        <div
            className={`newsletter container ${
                className ? className : ""
            } mb-10 lg:mb-24`}
        >
            <div className="relative py-10 px-10 text-center text-white lg:py-[61px]">
                <img
                    src="/newsletter-bg.svg"
                    alt=""
                    className="absolute inset-0 h-full w-full object-cover"
                />

                <div
                    className={`relative transition duration-300 ${
                        visibility ? "z-10" : "opacity-0"
                    }`}
                >
                    <h2 className="mb-4 text-2xl font-semibold text-white lg:text-[32px] lg:leading-snug">
                        Join Saigon Digital Newsletter
                    </h2>
                    <p className="mb-6 text-base lg:text-lg">
                        Get the exclusive Jamstack web dev case studies (and
                        more) in your mailbox!
                    </p>
                    <form
                        action=""
                        onSubmit={onSubmit}
                        class="z-10 mx-auto flex max-w-[540px] flex-col items-center gap-y-5 gap-x-[30px] sm:relative sm:flex-row lg:items-stretch"
                    >
                        <input
                            ref={$input}
                            type="text"
                            className="w-full rounded-full py-3 px-6 text-center text-base leading-4 text-grey placeholder:leading-4 md:text-left lg:min-w-[350px] lg:py-4"
                            placeholder="Type your email"
                        />
                        {error && (
                            <span className="text-sm text-red-500 sm:absolute sm:top-full sm:left-5 sm:mt-2">
                                {error}
                            </span>
                        )}
                        <Button
                            type="black"
                            onClick={onSubmit}
                            className="relative mt-0 rounded-full px-6 text-base font-semibold !tracking-normal hover:!bg-white hover:!text-black lg:!px-[50px] lg:!text-base"
                        >
                            submit
                        </Button>
                    </form>
                </div>

                <div
                    className={`absolute inset-0 grid place-items-center  text-2xl font-semibold text-white transition duration-300 lg:text-[32px] lg:leading-snug ${
                        visibility ? "opacity-0" : "z-10 opacity-100"
                    }`}
                >
                    {thankMess && <h2>{parse(thankMess)}</h2>}
                </div>
            </div>
        </div>
    )
}

export default Newsletter
